// @ts-nocheck
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../../runtime/json/scalar";
import { default as serialize, } from "../../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        year: "0",
        month: "0",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.year !== undefined)
        result.year = tsValueToJsonValueFns.int64(value.year);
    if (value.month !== undefined)
        result.month = tsValueToJsonValueFns.int64(value.month);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.year !== undefined)
        result.year = jsonValueToTsValueFns.int64(value.year);
    if (value.month !== undefined)
        result.month = jsonValueToTsValueFns.int64(value.month);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.year !== undefined) {
        const tsValue = value.year;
        result.push([1, tsValueToWireValueFns.int64(tsValue)]);
    }
    if (value.month !== undefined) {
        const tsValue = value.month;
        result.push([2, tsValueToWireValueFns.int64(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.year = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.month = value;
    }
    return result;
}
